import _ from 'lodash'

export function cleanOrderTypes (settingsBlob) {
  const orderTypes = _.get(settingsBlob, 'orderTypes.types', [])
  const kioskEnabledTypes = [1, 2, 3] // Dine In, To Go, Drive Thru

  orderTypes.forEach(ot => {
    if (!ot.hasOwnProperty('availableOnline') && ot.hasOwnProperty('activeOnline')) {
      ot.availableOnline = ot.activeOnline || false
    }
    if (!kioskEnabledTypes.includes(ot.id)) {
      ot.activeKiosk = false
    }
    if (ot.activeOnline && !ot.availableOnline) {
      ot.activeOnline = false
    }
    if (!ot.hasOwnProperty('activeSms')) {
      ot.activeSms = false
    }
  })
}
